export default __webpack_public_path__ + "static/media/inviteSidebar.05d64a5c.png";